import FormScreen from './FormScreen'
import CertificadosScreen from './CertificadosScreen'
import LoginScreen from './LoginScreen'
import CertificadosLoginScreen from './CertificadosLoginScreen'

let servicios = {
	"CONTROLVELOCIDAD" : {
		titulo:"Cambio de Límites",
		login_url:"http://192.175.109.132:8901/controlvel_login/",
		componente: FormScreen,
		componentelogin: LoginScreen,
	},
	"CERTIFICADOS" : {
		titulo:"Generación de Certificados",
		login_url:"//certificados.boltrack.net/dts/login/",
		componente: CertificadosScreen,
		componentelogin: CertificadosLoginScreen,
	},
}

export default servicios["CERTIFICADOS"];